<mat-form-field appearance="outline" class="officine-selector">
  <mat-label>Adhérent</mat-label>
  <input
    type="text"
    matInput
    placeholder="Adhérent"
    [formControl]="adherentCtrl"
    [matAutocomplete]="auto"
    (focus)="onInputFocus()"
  />
  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayFn"
    (optionSelected)="onAdherentSelected($event.option.value)"
    (closed)="onSelectorClosed()"
    autoActiveFirstOption
  >
    @for (adherent of filteredAdherents$ | async; track adherent) {
  <mat-option [value]="adherent">
    {{ adherent?.nomInterne ?? adherent?.nom ?? '' }}
  </mat-option>
    }
  </mat-autocomplete>
 
  <button matSuffix mat-icon-button aria-label="Clear" (click)="onClearAdherent()">
    <mat-icon>close</mat-icon>
  </button>
  
</mat-form-field>
